import {Component, Input, OnDestroy, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {CoreService} from '../../../../core/services/core.service';
import {TextSanitizerPipe} from '@xmedical/core';
import {Patient, Allergy} from '@xmedical/core';
import {PatientAllergiesStore, PatientStore} from '../../../../core/state';

@Component({
    selector: 'app-allergy-item',
    templateUrl: './allergy-item.component.html',
    styleUrl: './allergy-item.component.scss',
    standalone: false
})
export class AllergyItemComponent implements OnDestroy {
  private repositorySubscription: Subscription;
  error = '';
  loading = false;
  @Input() item: Allergy;
  @Input() usePrimaryText = false;

  private patientStore = inject(PatientStore);
  private allergiesStore = inject(PatientAllergiesStore);

  constructor(
    private coreService: CoreService,
    private textSanitizePipe: TextSanitizerPipe
  ) { }

  ngOnDestroy(): void {
    if (this.repositorySubscription) { this.repositorySubscription.unsubscribe(); }
  }

  get patient(): Patient | null {
    return this.patientStore.current();
  }

  get confirmationMessage(): string {
    if (!this.patient) {
      return 'Are you sure you want to remove ' + this.textSanitizePipe.transform(this.item.allergy) + '?';
    }
    return 'Are you sure you want to remove ' +
      this.textSanitizePipe.transform(this.item.allergy)  +
      ' from ' + this.patient.firstName + ' ' + this.patient.surname + '?';
  }

  public removeAllergyFromPatient(allergyId: number) {
    this.loading = true;
    this.error = '';
    this.repositorySubscription = this.allergiesStore.remove(allergyId).subscribe({
      next: () => {
        this.loading = false;
      },
      error: () => {
        this.error = 'Could not remove this allergy item from this patient';
        this.coreService.showErrorToast(this.error);
        this.loading = false;
      }
    });
  }
}
